"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decode = exports.encode = void 0;
const baseX_1 = require("./baseX");
const base32 = new baseX_1.default({
    dataBits: 8,
    codeBits: 5,
    keyString: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567',
    pad: '=',
});
/**
 * Encode raw string to base32
 *
 * @param input raw string
 * @returns encoded string
 */
function encode(input) {
    return base32.encode(input);
}
exports.encode = encode;
/**
 * Decode base32 to raw string
 *
 * @param input encoded string
 * @returns raw string
 */
function decode(input) {
    return base32.decode(input);
}
exports.decode = decode;
exports.default = {
    encode,
    decode,
};
